import { CLIENT } from '../constant/actionTypes';

const getClientUsersList = (state, action) => {
  switch (action.type) {
    case CLIENT.USER_LIST.INITIATE:
      return { isFetching: true, data: action.payload };
    case CLIENT.USER_LIST.SUCCESS:
      return { isFetching: false, data: action.payload };
    case CLIENT.USER_LIST.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? {} : state;
  }
};

export default getClientUsersList;
